const AuthActionTypes = {
    VALIDATE_CODE: "VALIDATE_CODE",

    SIGNIN_START: "SIGNIN_START",
    SIGNIN_SUCCESS: "SIGNIN_SUCCESS",
    SIGNIN_FAILURE: "SIGNIN_FAILURE",

    UPDATE_SUBSCRIPTION: "UPDATE_SUBSCRIPTION",
    UPDATE_EMPLOYEE: "UPDATE_EMPLOYEE",

    SIGN_OUT: "SIGN_OUT",
    RESET: "RESET",
};

export default AuthActionTypes;
